
import sheet from '../assets/images/sheet.png'
import deathSound from '../assets/sounds/death.mp3'
import squealSound from '../assets/sounds/squeal.mp3'

const image = new Image()
image.src = sheet

const Sheet = {
  RIGHT: [3, 2],
  LEFT: [3, 1],
  UP: [1, 2],
  DOWN: [2, 2],

  RIGHT_OPEN: [7, 2],
  LEFT_OPEN: [7, 1],
  DOWN_OPEN: [6, 2],
  UP_OPEN: [5, 2],

  BODY_RIGHT_RIGHT: [1, 1],
  BODY_LEFT_LEFT: [1, 1],
  BODY_DOWN_DOWN: [0, 2],
  BODY_UP_UP: [0, 2],
  BODY_LEFT_DOWN: [0, 1],
  BODY_UP_RIGHT: [0, 1],
  BODY_DOWN_RIGHT: [0, 3],
  BODY_LEFT_UP: [0, 3],
  BODY_UP_LEFT: [0, 0],
  BODY_RIGHT_DOWN: [0, 0],
  BODY_RIGHT_UP: [0, 4],
  BODY_DOWN_LEFT: [0, 4],

  BULGE_RIGHT_RIGHT: [5, 1],
  BULGE_LEFT_LEFT: [5, 1],
  BULGE_UP_RIGHT: [4, 1],
  BULGE_LEFT_DOWN: [4, 1],
  BULGE_RIGHT_DOWN: [4, 0],
  BULGE_UP_LEFT: [4, 0],
  BULGE_UP_UP: [4, 2],
  BULGE_DOWN_DOWN: [4, 2],
  BULGE_DOWN_RIGHT: [4, 3],
  BULGE_LEFT_UP: [4, 3],
  BULGE_RIGHT_UP: [5, 3],
  BULGE_DOWN_LEFT: [5, 3],

  TAIL_DOWN: [1, 4],
  TAIL_UP: [2, 4],
  TAIL_LEFT: [3, 4],
  TAIL_RIGHT: [4, 4],
}

const Snake = (x, y) => kontra.sprite({
  x,
  y,
  dir: RIGHT,
  lastDir: RIGHT,
  nextDir: RIGHT,
  width: 16,
  height: 16,
  color: 'lightgreen',
  length: 8,
  trail: [
    { 
      x,
      y,
      dir: RIGHT
    },
    { 
      x: x - GRID,
      y,
      dir: RIGHT
    },
    {
      x: x - GRID * 2,
      y,
      dir: RIGHT
    }
  ],
  water: 0,
  image,

  cut(amount) {
    this.length -= amount
    if (this.length < 1) {
      this.length = 1
    }
  },

  die() {
    const audio = kontra.assets.audio[deathSound].cloneNode()
    // const squeal = kontra.assets.audio[squealSound].cloneNode()
    audio.volume = 0.2
    audio.play()
    // squeal.play()
    stopped = true
    setTimeout(() => gameover = true, 500)
  },

  update() {
    this.dir = this.nextDir

    switch (this.dir) {
    case LEFT:
      this.x -= GRID
      if (this.x < 0) {
        this.x = MAP_WIDTH * GRID
      }
      break
    case RIGHT:
      this.x += GRID
      if (this.x > MAP_WIDTH * GRID) {
        this.x = 0
      }
      break
    case UP:
      this.y -= GRID
      if (this.y < -1) {
        this.y = (MAP_HEIGHT - 1) * GRID
      }
      break
    case DOWN:
      this.y += GRID
      if (this.y > (MAP_HEIGHT - 1) * GRID) {
        this.y = 0
      }
      break
    }

    this.lastDir = this.dir

    this.trail.unshift({ x: this.x, y: this.y, dir: this.dir })
    
    while (this.trail.length > this.length) {
      this.trail.pop()
    }

    if (this.water > this.length - 2) {
      this.water = this.length - 2
    }

    const { tx, ty } = getTilePos(this)
    const featureTile = map.getTile(1, tx, ty)

    if (featureTile.type === Tiles.ROCK) {
      this.die()
    }

    for (const {x, y} of this.trail.slice(1)) {
      if (this.x === x && this.y === y) {
        this.bitSelf = true
        this.die()
      }
    }
  },

  render() {
    let sx, sy

    const { tx, ty } = getTilePos(this)

    // get next pos
    let nx = tx
    let ny = ty
    switch (this.lastDir) {
    case LEFT:
      nx--
      break
    case RIGHT:
      nx++
      break
    case UP:
      ny--
      break
    case DOWN:
      ny++
      break
    }

    let openMouth = false

    if (this.bitSelf) {
      openMouth = true
    }

    // draw trail
    this.trail.forEach((cell, i) => {
      if (i === 0) {
        return
      }

      if (cell.x === nx * GRID && cell.y === ny * GRID) {
        openMouth = true
      }

      const prevCell = this.trail[i - 1]
      
      if (!prevCell) {
        return
      }

      if (i === this.trail.length - 1) {
        ;[sx, sy] = Sheet[`TAIL_${prevCell.dir}`]
      } else {
        const bodyType = this.water > i - 1 ? 'BULGE' : 'BODY'
        ;[sx, sy] = Sheet[`${bodyType}_${cell.dir}_${prevCell.dir}`]
      }
      
      this.context.drawImage(
        image,
        sx * 16, sy * 16, 16, 16,
        cell.x, cell.y, this.width, this.height
      )
    })

    const nextFeatureTile = map.getTile(1, nx, ny)

    if (this.water < this.length - 2 && nextFeatureTile && nextFeatureTile.type === Tiles.WATER) {
      openMouth = true
    }

    const existingCrop = crops.find(crop => {
      const cropPos = getTilePos(crop)
      return cropPos.tx === nx && cropPos.ty === ny
    })

    if (existingCrop && existingCrop.growth === 4) {
      openMouth = true
    }

    // draw head

    ;[sx, sy] = Sheet[this.lastDir + (openMouth ? '_OPEN' : '')]

    this.context.drawImage(
      image,
      sx * 16, sy * 16, 16, 16,
      this.x, this.y, this.width, this.height
    )
  }
})

export default Snake